import { useQuery } from '@tanstack/react-query'
import { fetchMfaStatus } from '@/auth/mfaStatus'
import { isDemoSession, getAccessToken } from '@/auth/oidc'
import { keys } from '@/api/hooks/shared/keys'

export function useMfaStatus() {
  const enabled = !isDemoSession() && Boolean(getAccessToken())
  return useQuery({
    queryKey: keys.mfaStatus,
    queryFn: fetchMfaStatus,
    enabled,
    staleTime: 15_000,
    refetchOnWindowFocus: true,
  })
}
